module.exports = __webpack_public_path__ + "img/videowiki.b4478666.svg";